import './NoFleetSim.scss';

import Button from '@mui/material/Button';

export function NoFleetSim() {
  return (
    <div>
      <p className="ss-no-fleet__label">Fleet Not yet Available in my ACcess</p>
      <p className="ss-no-fleet__text">
        The selected fleet hasn’t transitioned to the new system.{' '}
      </p>
      <p className="ss-no-fleet__text">
        In the meantime, you can access it through the existing system below.
      </p>
      <Button
        className="ss-no-fleet__button"
        onClick={() => {
          window.open(
            'https://aircanada.sharepoint.com/sites/ACaeronet/Redirect.html?app=FOPS-ReportLink',
            '_blank'
          );
        }}
      >
        Open ReportLink
      </Button>
    </div>
  );
}
